const mainViewStyle = (theme) => ({
  mainViewContainer: {
    maxWidth: 1200,
    margin: "auto",
  },
  gridMain: {
    padding: 9,
  },
  gridSide: {
    padding: 9,
  },
  link: {
    textDecoration: "none",
  },
});
export default mainViewStyle;
